import * as moment from 'moment';

import * as AccountModel from 'models/account';

import { BIRTH_DATE_FORMAT, SERVER_BIRTH_DATE_FORMAT } from 'constants/account';
import { API_PATH, VERIFICATION_EMAIL_ADDRESS_PATH, VERIFICATION_FORGOT_PASSWORD_EMAIL_PATH } from 'constants/app';
import { api } from 'helper/api';
import { app } from 'helper/app';
import { formatE164Phone, formatUsername } from 'helper/form';

export function updateEmail(formValue: AccountModel.AccountEmailUpdateForm): Promise<AccountModel.Account> {
  const emailVerificationUrl = app.generateUrl(VERIFICATION_EMAIL_ADDRESS_PATH);
  return api.build().withOAuth()
    .patch(`${API_PATH}/accounts/me/email`, {
      email: formValue.email,
      emailVerificationUrl
    });
}

export function getUnverifiedEmail(): Promise<AccountModel.AccountGetUnverifiedEmailResponse> {
  return api.build().withOAuth()
    .get(`${API_PATH}/accounts/me/unverified-email`);
}

export function updatePassword(formValue: AccountModel.AccountPasswordUpdateForm): Promise<AccountModel.Account> {
  return api.build().withOAuth()
    .patch(`${API_PATH}/accounts/me/password`, {
      newPassword: formValue.newPassword,
      password: formValue.password
    });
}

export function forgotPassword(formValue: AccountModel.AccountForgotPasswordForm): Promise<AccountModel.AccountForgotPasswordResponse> {
  const emailVerificationUrl = app.generateUrl(VERIFICATION_FORGOT_PASSWORD_EMAIL_PATH);
  return api.build().withoutAuth()
    .post(`${API_PATH}/accounts/forgot-password`, {
      emailVerificationUrl,
      username: formatUsername(formValue.username)
    });
}

export function confirmForgotPassword(formValue: AccountModel.AccountForgotPasswordOtpForm): Promise<void> {
  return api.build().withoutAuth()
    .patch(`${API_PATH}/accounts/forgot-password/phone`, {
      newPassword: formValue.newPassword,
      otp: formValue.otp,
      phone: formatE164Phone(formValue.phone)
    });
}

export function getLoginHistories(): Promise<AccountModel.AccountLoginHistoryList> {
  return api.build().withOAuth()
    .get(`${API_PATH}/accounts/me/login-histories`);
}

export function register(formValue: AccountModel.AccountRegisterForm): Promise<AccountModel.Account> {
  const emailVerificationUrl = app.generateUrl(VERIFICATION_EMAIL_ADDRESS_PATH);
  return api.build().withoutAuth()
    .post(`${API_PATH}/accounts/validate`, {
      email: formValue.email,
      emailVerificationUrl,
      password: formValue.password,
      phone: formatE164Phone(formValue.phone)
    });
}

export function confirmRegister(formValue: AccountModel.AccountRegisterOtpForm): Promise<void> {
  const emailVerificationUrl = app.generateUrl(VERIFICATION_EMAIL_ADDRESS_PATH);
  return api.build().withoutAuth()
    .post(`${API_PATH}/accounts`, {
      email: formValue.email,
      emailVerificationUrl,
      otp: formValue.otp,
      password: formValue.password,
      phone: formatE164Phone(formValue.phone)
    });
}

export function updateStore(formValue: AccountModel.AccountStoreForm): Promise<AccountModel.AccountStore> {
  return api.build().withOAuth()
    .post(`${API_PATH}/accounts/me/store`, {
      storeAddress: formValue.address,
      storeName: formValue.name,
      storeUrl: formValue.url
    });
}

export function updateProfile(formValue: AccountModel.AccountProfileForm): Promise<AccountModel.AccountProfile> {
  return api.build().withOAuth()
    .patch(`${API_PATH}/accounts/me/profile`, {
      address: formValue.address,
      birthDate: moment.utc(formValue.birthDate, BIRTH_DATE_FORMAT).format(SERVER_BIRTH_DATE_FORMAT),
      birthPlace: formValue.birthPlace,
      motherName: formValue.motherName,
      name: formValue.name,
      nationalCardNumber: formValue.nationalCardNumber
    });
}

export function uploadNationalCardScan(nationalCardScan: File): Promise<void> {
  const formData = new FormData();
  formData.append('national_card_scan', nationalCardScan);

  return api.build().withOAuth()
    .postWithFormData(`${API_PATH}/accounts/me/profile/national-card-scan`, formData);
}

export function uploadNationalCardSelfie(nationalCardSelfie: File): Promise<void> {
  const formData = new FormData();
  formData.append('national_card_selfie', nationalCardSelfie);

  return api.build().withOAuth()
    .postWithFormData(`${API_PATH}/accounts/me/profile/national-card-selfie`, formData);
}

export function uploadStoreAvatar(avatarFile: File): Promise<AccountModel.AccountStore> {
  const formData = new FormData();
  formData.append('avatar', avatarFile);

  return api.build().withOAuth()
    .postWithFormData(`${API_PATH}/accounts/me/store/avatar`, formData);
}

export function validatePhone(formValue: AccountModel.AccountPhoneForm): Promise<AccountModel.Account> {
  return api.build().withOAuth()
    .post(`${API_PATH}/accounts/me/phone/validate`, {
      phone: formatE164Phone(formValue.phone)
    });
}

export function confirmPhone(formValue: AccountModel.AccountPhoneOtpForm): Promise<void> {
  return api.build().withOAuth()
    .patch(`${API_PATH}/accounts/me/phone`, {
      otp: formValue.otp,
      phone: formatE164Phone(formValue.phone)
    });
}

export function get(): Promise<AccountModel.Account> {
  return api.build().get(`${API_PATH}/accounts/me`);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/repositories/account.ts